import cloneDeep from 'lodash/cloneDeep';
import * as Types from './actionTypes';

const initialState = {
  categories: {},
  shippers: [],
  preBook: {},
  bookingStep: 'NEW',
};

const reducer = function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case Types.INIT_CATEGORIES: {
      const newState = cloneDeep(state);
      newState.categories = payload.categories;
      return newState;
    }
    case Types.INIT_SHIPPERS: {
      const newState = cloneDeep(state);
      newState.shippers = payload.shippers || [];
      return newState;
    }
    case Types.PREPARE_PRE_BOOK: {
      const newState = cloneDeep(state);
      newState.preBook = payload;
      return newState;
    }
    case Types.DESTROY_PRE_BOOK: {
      const newState = cloneDeep(state);
      newState.preBook = {};
      return newState;
    }
    case Types.SET_BOOKING_STEP: {
      const newState = cloneDeep(state);
      newState.bookingStep = payload.step;
      return newState;
    }
    default:
      return state;
  }
};

export default reducer;
